import { inject, Injectable } from "@angular/core";
import { UiSettings } from "src/app/backend/models/settings/ui-settings";
import { UserBackend } from "src/app/backend/api/user.backend";
import { Observable } from "rxjs";

@Injectable()
export class SettingsService {
  private readonly userBackend = inject(UserBackend);

  private uiSettings: UiSettings | undefined;

  getUiSettings(): UiSettings {
    return this.uiSettings!;
  }

  setUiSettings(value: UiSettings): void {
    this.uiSettings = value;
  }

  updateUiSetting(uiSetting: Partial<UiSettings>): Observable<void> {
    return this.updateUiSettings({
      ...this.uiSettings,
      ...uiSetting
    });
  }

  updateUiSettings(uiSettings: UiSettings): Observable<void> {
    this.uiSettings = uiSettings;
    return this.userBackend.updateUiSettings(uiSettings);
  }
}
